import axios from "axios";

const adminApi = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/admin`,
  timeout: 30000,
});

adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("staff_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const apiError = (e, fallback = "Une erreur est survenue.") => {
  const d = e.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").filter(Boolean).join(" ");
  return fallback;
};

export const logout = () => {
  localStorage.removeItem("staff_token");
  localStorage.removeItem("staff_user");
  window.location.href = "/admin/login";
};

export default adminApi;
